var _path, _line, _polyline, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112,168V80H212a32,32,0,0,1,32,32v56",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 208,
    x2: 24,
    y2: 48,
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "24 168 244 168 244 208",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 80,
    x2: 24,
    y2: 80,
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.bad5a732674e3dc7353569d690e78c10.svg";
export { ForwardRef as ReactComponent };